<template>
  <LoadingBar
    v-if="loading === true || error.message.length"
    :error="error.message"
  ></LoadingBar>
  <Page v-else title="Billing Accounts - Manage">
    <BillingAccounts />
  </Page>
</template>
<script>
import BillingAccounts from "@/components/accounts/BillingAccounts";
import Page from "@/components/layout/Page";
import LoadingBar from "@/components/loaders/LoadingBar";
import { mapState } from "vuex";

export default {
  name: "ManageBillingAccounts",
  components: { Page, BillingAccounts, LoadingBar },
  computed: {
    ...mapState("auth", ["user"])
  },
  data() {
    return {
      error: {
        message: ""
      }
    };
  },
  mounted() {
    if (this.user.is_copy_to) {
      this.error.message = "Report Recipient has no access to this page";
      return;
    }
  }
};
</script>
